var ColumnGroupStyle = {};

export { ColumnGroupStyle as default };
